import { DEFAULT_QUERY } from '../constants';
import { EditableQuery } from '../types/query';

export const createBlankQuery = (query?: Partial<EditableQuery>): EditableQuery => ({
  ...DEFAULT_QUERY,
  ...query,
});
